import { Link } from "react-router-dom";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";

/**
 * Full-width sunlit photo band for the Konaseema guide.
 * A slowly drifting, edge-to-edge strip of golden-hour photographs with a warm
 * sunlight glaze, sitting right above the main photo gallery.
 */
export default function KonaseemaGalleryBand() {
  const { bandImages } = useKonaseemaGuide();
  const driftImages = [...bandImages, ...bandImages];

  return (
    <section
      aria-label="Sunlit views of Konaseema — backwaters, paddy fields and coconut groves"
      className="relative w-full overflow-hidden bg-foreground-950"
    >
      <div className="flex w-max gallery-drift">
        {driftImages.map((image, index) => (
          <div
            key={`konaseema-band-${index}`}
            aria-hidden={index >= bandImages.length}
            className="relative h-[220px] md:h-[340px] w-[280px] md:w-[420px] shrink-0 mr-2 md:mr-3 overflow-hidden"
          >
            <img
              src={image.src}
              width={1200}
              height={900}
              alt={image.alt}
              title="Konaseema travel guide - golden hour photography"
              className="w-full h-full object-cover object-top"
              decoding="async"
            />
          </div>
        ))}
      </div>

      {/* Warm sunlit glaze over a soft vignette so the band echoes the golden photography */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/10 to-foreground-950/55"></div>
      <div className="pointer-events-none absolute inset-0 sun-glaze"></div>

      {/* Tap-through caption linking down to the season guide and the trip planner */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10">
        <div className="w-full px-4 md:px-8 pb-4 md:pb-6">
          <div className="pointer-events-auto rounded-lg bg-foreground-950/55 backdrop-blur-md border border-background-50/15 px-4 py-3.5 md:px-6 md:py-4 flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
            <p className="text-xs md:text-sm text-background-50 leading-relaxed max-w-xl">
              Golden mornings over the Godavari delta — every season paints Konaseema a little
              differently.
            </p>
            <div className="flex flex-wrap gap-2 md:gap-3 md:ml-auto">
              <a
                href="#best-season"
                className="inline-flex items-center gap-1.5 bg-accent-500 text-background-50 text-xs md:text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-sun-line"></i>
                Best Season &amp; Tips
              </a>
              <Link
                to="/plan-your-trip"
                className="inline-flex items-center gap-1.5 bg-background-50/10 border border-background-50/40 text-background-50 text-xs md:text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-route-line"></i>
                Plan Your Trip
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}